import React, { useEffect, useState } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import Box from "@mui/material/Box";

import { useAppCustomStyles } from "../../assets/theme/custom/hooks";
import { setMiniSidenav, useMaterialUIController } from "../../context";

function SidenavCollapsible({ icon, name, children, active = false, ...rest }: any) {
  const custom = useAppCustomStyles();
  const sidenav = custom.widgets.sidenav;
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;

  const [open, setOpen] = useState(false);

  // Mini rail must never show nested children — keep groups closed while collapsed.
  useEffect(() => {
    if (miniSidenav) setOpen(false);
  }, [miniSidenav]);

  const handleClick = () => {
    if (miniSidenav) {
      setMiniSidenav(dispatch, false);
      setOpen(true);
      return;
    }
    setOpen((prev) => !prev);
  };

  const collapseState = {
    active,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
    miniSidenav,
  };

  return (
    <>
      <ListItem component="li" disablePadding>
        <Box
          {...rest}
          onClick={handleClick}
          sx={sidenav.collapsibleItem({ ...collapseState, miniSidenav })}
        >
          <ListItemIcon sx={sidenav.collapseIconBox(collapseState)}>
            {typeof icon === "string" ? (
              <Icon sx={sidenav.collapseIcon(collapseState)}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={sidenav.collapseText({ ...collapseState, miniSidenav })}
          />

          {!miniSidenav ? <Icon sx={sidenav.expandIcon(open)}>expand_more</Icon> : null}
        </Box>
      </ListItem>

      <Collapse in={!miniSidenav && open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </>
  );
}

// Typechecking props for the SidenavCollapsible
SidenavCollapsible.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
};

export default SidenavCollapsible;
